import {GeneralTypeModel} from '../models/general-type.model';
import {SourceTypeEnum} from './source-type.enum';

export enum ReminderLogStatusEnum {
  Pending = 0,
  Sent = 1,
  Failed = 2,
}

export function reminderLogStatusEnumToGeneralTypeModel(type: ReminderLogStatusEnum | null): GeneralTypeModel {
  switch (type) {
    case ReminderLogStatusEnum.Pending:
      return { name: 'Pending', color: '#aab900'};
    case ReminderLogStatusEnum.Sent:
      return { name: 'Sent', color: '#00a798'};
    case ReminderLogStatusEnum.Failed:
      return { name: 'Failed', color: '#aa0000'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
